import React from "react"
import { Container, Row, Col } from "reactstrap"
import styled from "styled-components"
import classNames from "classnames"

const RowStyled = styled(Row)`
    &:first-child {
        border-top: 1px solid ${props => props.theme.colors.primary};
    }

    > div {
        background-color: black;
        color: white;
        text-transform: uppercase;
        padding-top: .3rem;
        padding-bottom: .3rem;
        border-bottom: 1px solid ${props => props.theme.colors.primary};
        font-size: ${props => props.theme.font.size.base};

        p {
            margin: 0;
        }

        &:last-child {
            background-color: #f3f3f3;
            color: black;
            // font-family: ${props => props.theme.font.family.bold};

            p {
                margin: 0;
                display: flex;
                align-items: center;
            }
        }
    }

    &.darkStripped {
        > div {
            background-color: #575757;

            &:last-child {
                background-color: white;
            }
        }
    }

    img {
        padding-right: .25rem;
    }
`

const StatsTable = (props) => {
    const { stats } = props
    return(
        <Container fluid className="pb-4">
            {stats && stats.map((stat, i) => {
                return(
                    <RowStyled key={i} className={classNames({
                        darkStripped: i % 2
                    })}>
                        <Col xs={12} sm={6}>
                            {stat.name}
                        </Col>
                        <Col xs={12} sm={6}>
                            <div dangerouslySetInnerHTML={{ __html: stat.value}} />
                        </Col>
                    </RowStyled>
                )
            })}
        </Container>
    )
}

export default StatsTable